import { HttpClient } from "@angular/common/http";
import { UrlServidor } from "../util/url-servidor";
import { Injectable } from "@angular/core";
import { Observable, of, tap } from "rxjs";
import { DanfeCstEmpresa } from "../api/dto/danfe/danfe-cst-empresa";
import { CacheService } from "./cache/cache.service";

@Injectable({
    providedIn: 'root',
})
export class DanfeCstEmpresaService {
    constructor(private http: HttpClient, private cacheService: CacheService<DanfeCstEmpresa[]>) { }

    private url : string = UrlServidor.URL_BASE + 'danfe-cst-empresa';
    private cacheKey = 'danfe-cst-empresa';
    private expiration = 240 * 60 * 1000;

    listar(): Observable<DanfeCstEmpresa[]>{
        const cachedData = this.cacheService.get(this.cacheKey);

        if (cachedData) {
            return of(cachedData);
        } else {
            return this.http.get<DanfeCstEmpresa[]>(this.url)
            .pipe(
                tap(response => this.cacheService.set(this.cacheKey, response, this.expiration))
              );
        }
    }
}